import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { Helmet } from 'react-helmet-async';
import { FaPlus } from 'react-icons/fa';
import heroPcGaming from '../assets/hero-pc-gaming.jpg';
import heroPcGamingMobile from '../assets/compressed/mobile/hero-pc-gaming.jpg';
import heroPcGamingTablet from '../assets/compressed/tablet/hero-pc-gaming.jpg';
import './PcGaming.css';
import ForumDiscussion from '../components/Forum/ForumDiscussion';
import NouvDiscModal from '../components/Forum/NouvDiscModal';
import useForumPagination from '../hooks/useForumPagination';

const PcGaming = () => {
    const [showModal, setShowModal] = useState(false);
    const { currentUser } = useAuth();
    const {
        discussions,
        loading,
        hasMore,
        loadMore,
        refreshDiscussions
    } = useForumPagination('pc-gaming-discussions');

    return (
        <main className="pc-gaming-page">
            <Helmet>
                <title>PC Gaming : Guide Complet et Optimisation - Tech Passion</title>
                <meta name="description" content="Tout sur le PC Gaming : configuration optimale, composants gaming, optimisation des performances, nouveaux jeux PC et guides d'amélioration. Conseils d'experts pour une expérience de jeu optimale." />
                <link rel="canonical" href="https://techpassion.fr/pc-gaming" />
                <meta name="keywords" content="PC gaming, jeux PC, configuration gaming, optimisation jeux, composants gaming, performance gaming, GPU gaming, gaming hardware" />
                <meta property="og:title" content="PC Gaming : Guide Complet et Optimisation - Tech Passion" />
                <meta property="og:description" content="Découvrez comment optimiser votre PC Gaming : guides, conseils et astuces pour une expérience de jeu exceptionnelle." />
                <meta property="og:url" content="https://techpassion.fr/pc-gaming" />
                <meta property="og:type" content="website" />
            </Helmet>

            <section className="hero">
                <div className="hero-left">
                    <div className="hero-content">
                        <h1>PC Gaming</h1>
                        <p>Découvrez tout sur les configurations gaming et optimisez vos performances</p>
                    </div>
                </div>
                <img 
                    className="hero-image"
                    src={heroPcGaming}
                    srcSet={`${heroPcGamingMobile} 480w, ${heroPcGamingTablet} 768w, ${heroPcGaming} 1024w`}
                    sizes="(max-width: 768px) 100vw, 50vw"
                    alt="Configuration gaming avec carte graphique puissante, RGB et système de refroidissement avancé"
                    loading="lazy"
                />
            </section>

            <section className="discussions-section">
                {loading ? (
                    <div className="loading">Chargement des discussions...</div>
                ) : (
                    <div className="discussions-container">
                        {discussions.map(discussion => (
                            <ForumDiscussion
                                key={discussion.id}
                                discussion={discussion}
                                collectionName="pc-gaming-discussions"
                                onReply={refreshDiscussions}
                            />
                        ))}
                    </div>
                )}

                {hasMore && (
                    <div className="load-more-container">
                        <button 
                            className="load-more-btn"
                            onClick={loadMore}
                        >
                            Voir plus
                        </button>
                    </div>
                )}
            </section>

            {currentUser && (
                <button 
                    className="new-discussion-button" 
                    title="Nouvelle discussion"
                    onClick={() => setShowModal(true)}
                >
                    <FaPlus />
                </button>
            )}

            <NouvDiscModal 
                isOpen={showModal}
                onClose={() => setShowModal(false)}
                forumId="pc-gaming-discussions"
                onDiscussionUpdate={refreshDiscussions}
            />
        </main>
    );
};

export default PcGaming;
